module.exports = __webpack_public_path__ + "static/diana-2a079b833a9a9b45ef898baa443ed0d8.jpg";